// Custom Signup Flow support for /gp/ AI-generated pages — mirrors the Generator's Page Settings
// "Custom Signup Flow" field (components/templates-generator/config/index.js → customSignupFlow),
// which appends a custom_flow query param to every signup button on a regular Generator page via
// React context (contexts/generic-config-context.js → SignupCoreComponent). /gp/ pages have no
// React page-settings system — they're self-contained HTML enhanced client-side by the `ap`
// bundle (homepage-webflow) — so this reaches the same outcome through that bundle's existing,
// generic mechanism instead of re-implementing query-param logic here.
//
// homepage-webflow's signup.js already supports a PAGE-LEVEL (not just per-button) custom flow
// value: it reads window.pageConfig["custom-flow-value"] (src/services/page-config-service.js →
// getPageConfigProperty) and appends it as `custom_flow` to every [data-button-type="signup"]
// button on the page — header included, since the header CTA is just another element carrying
// that same data attribute. Normally that property is populated from a Webflow CMS
// "Configurations" entry (custom-flow-value.js). /gp/ pages have no such CMS entry, so instead we
// plant the same window.pageConfig property directly via an inline script, before any bundle
// script runs.
//
// CROSS-REPO CONTRACT with homepage-webflow (coordinate any rename):
//   - property name is exactly "custom-flow-value" (page-config-service.js)
//   - must be written additively (Object.assign onto whatever window.pageConfig already is),
//     matching addPropertyToPageConfig's spread — the CMS-driven sync applications write their
//     own properties onto the same object and must not be clobbered, and vice versa.
//   - must run before the `ap` bundle's signup.js executes. Inserting it just before </head> (the
//     same anchor + shared helper every other /gp/ render-time injector here uses) is early enough:
//     </head> always precedes <body>, and the bundle's BODY_SCRIPTS (which is where signup.js
//     lives) are planted just before </body> — so this script's document position is guaranteed
//     to run first regardless of where in <head> it lands.
const { insertBeforeClosingTag } = require("../../utils/html-utils");
const CUSTOM_FLOW_VALUE_PROPERTY_NAME = "custom-flow-value";
const buildCustomSignupFlowScript = (customSignupFlow)=>{
    // JSON.stringify gives a safe JS string literal; neutralize "</script" the same way
    // seo-tags.js does for jsonLdSchema, so the value can't prematurely close the tag.
    const safeValue = JSON.stringify(String(customSignupFlow)).replace(/<\/script/gi, "<\\/script");
    return `<script>window.pageConfig = Object.assign({}, window.pageConfig, { "${CUSTOM_FLOW_VALUE_PROPERTY_NAME}": ${safeValue} });</script>`;
};
// Applied at render time (not baked into stored HTML at publish), mirroring seo-tags.js /
// prefetch-tags.js, so editing customSignupFlow via the update endpoint takes effect immediately
// without republishing html. Uses the same insertBeforeClosingTag helper those files (and
// bundle-scripts.js) use, so it matches </head> the same case-insensitive, attribute-agnostic,
// last-occurrence way as every other tag this endpoint injects, with the same missing-tag fallback.
const applyCustomSignupFlow = (html, pageConfig = {})=>{
    const { customSignupFlow } = pageConfig;
    if (!customSignupFlow) return html;
    const script = buildCustomSignupFlowScript(customSignupFlow);
    return insertBeforeClosingTag(html, "</head>", script, (h, s)=>`${s}\n${h}`);
};
module.exports = {
    applyCustomSignupFlow,
    CUSTOM_FLOW_VALUE_PROPERTY_NAME
};
